import module from 'empresa/module.js'
import template from './template.html'

export class EmpresaClientesEliminarComponent {
  empresaId
  data
  eliminando = false
  onDelete

  eliminar (data) {
    this.eliminando = false

    if (data.exito) {
      this.onDelete()
    }
  }
}

module.component('empresaClientesEliminar', {
  controller: EmpresaClientesEliminarComponent,
  template,
  bindings: {
    empresaId: '<',
    data: '<',
    onDelete: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/clientes/eliminar/component.js